import React, { useState } from 'react';
import PageLoader from '../../../../../component/PageLoader';
import useUsers from './hooks/useUsers';
import { IoIosArrowRoundDown, IoIosArrowRoundUp } from 'react-icons/io';
import Table from '../../../../../component/table/Table';
import CreateUserModal from './components/createUserModal';
import UserDrawer from './components/userDrawer';
import SettingHeaderComponent from '../../components/settingHeaderComponent';

import SubscriptionUsageIndicator from '../../../../../component/SubscriptionUsageIndicator';
import useUsageIndicator from '../../../../../hooks/useUsageIndicator';

export default function SettingsUsers({ activeTab }) {
	const { usageData } = useUsageIndicator();
	const {
		usersList,
		getUsersList,
		headerDropDown,
		setHeaderDropDown,
		loader,
		sortDataList,
		sortDirection,
		handleFilterData,
		setBulkAction,
		bulkAction,
		onRowClick,
		handleDeselectAll,
		handleDisable,
		capacity,
	} = useUsers();
	const [isOpenModel, setIsOpenModal] = useState(false);
	const [isDrawerOpen, setIsDrawerOpen] = useState(false);
	const [isEdit, setIsEdit] = useState(false);
	const [selectedUserId, setSelectedUserId] = useState('');
	const sortIconMap = {
		asc: <IoIosArrowRoundUp />,
		desc: <IoIosArrowRoundDown />,
	};

	const usersTableColumn = [
		{
			field: '',
			headerClass: 'HeaderBg',
			checkboxSelection: true,
			headerCheckboxSelection: true,
			minWidth: 50,
			maxWidth: 50,
			autoHeight: true,
			lockPosition: true,
			cellRenderer: (params) => {
				return (
					<div className="d-flex align-items-center" style={{ height: '85px' }}>
						<input
							type="checkbox"
							checked={bulkAction.includes(params.data.id)}
							onChange={(e) => {
								const value = e.target.checked;
								if (value) {
									var newList = [...bulkAction, params.data.id];
									setBulkAction(newList);
								} else {
									var updatedList = bulkAction.filter((data) => data !== params.data.id);
									setBulkAction(updatedList);
								}
							}}
						/>
					</div>
				);
			},
		},
		{
			field: 'USER DETAILS',
			headerClass: 'HeaderBg',
			suppressSizeToFit: true,
			minWidth: 500,
			flex: 1,
			autoHeight: true,
			cellClass: 'left-align',
			headerComponent: () => {
				return (
					<div
						style={{
							width: '100%',
							paddingTop: '10px',
							cursor: 'pointer',
						}}
						onClick={() => sortDataList({ order_by: 'first_name', sort_by: 'asc' })}
					>
						<div
							style={{
								width: '55px',
							}}
						>
							<p
								style={{
									display: 'flex',
									alignItems: 'center',
									color: 'black',
								}}
							>
								USER DETAILS
								<span
									style={{
										fontSize: '18px',
										fontWeight: '800',
									}}
								>
									{sortIconMap[sortDirection?.first_name]}
								</span>
							</p>
						</div>
					</div>
				);
			},
			cellRenderer: (params) => {
				const data = JSON.parse(params.data['user']);
				return (
					<div className="d-flex gap-3 align-items-center">
						<div
							className="text-center fs-4 d-flex justify-content-center align-items-center"
							style={{
								backgroundColor: '#D9D9D9',
								borderRadius: '30px',
								width: '60px',
								height: '60px',
								padding: '5px',
							}}
						>
							{data.name
								.split(' ')
								.map((w) => w[0])
								.join('')
								.toUpperCase()}
						</div>
						{/* Fixed per-line heights removed. Each line was pinned to 25px
						    (45px for status), which forced the row tall regardless of
						    content and left a gap under every cell. Line height now comes
						    from the text itself. */}
						<div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
							<div
								className="fw-semibold cursor-pointer"
								style={{ color: '#2E63F6', fontSize: '13px', lineHeight: '1.5', marginTop: '8px' }}
								onClick={(e) => {
									e.stopPropagation();
									setIsDrawerOpen(true);
									setSelectedUserId(data.id);
								}}
							>
								{data?.name}
							</div>
							<div className="fw-light text-dark" style={{ fontSize: '11px', lineHeight: '1.5' }}>{data?.phone_number}</div>
							<div className="fw-light text-dark" style={{ fontSize: '11px', lineHeight: '1.5' }}>
								{data?.is_draft ? (
									<span style={{ fontStyle: 'italic', color: '#6c757d' }}>Email not set yet</span>
								) : (
									data?.email
								)}
							</div>
							{/* Draft is a third state, not a shade of Active/Inactive: the
							    account exists and occupies a seat but has never been usable.
							    Labelling it "Inactive" would suggest someone switched it off. */}
							<div
								className="fw-semibold"
								style={{
									fontSize: '11px',
									lineHeight: '1.5', marginBottom: '6px',
									color: data.is_draft ? '#B8860B' : data.is_active ? '#4CAE14' : '#DC3545',
								}}
							>
								{data?.is_draft ? 'Draft' : data?.is_active ? 'Active' : 'Inactive'}
							</div>
						</div>
					</div>
				);
			},
		},
		{
			field: 'ROLES',
			headerClass: 'HeaderBg',
			suppressSizeToFit: true,
			minWidth: 200,
			flex: 1,
			cellClass: 'center-align',
			headerComponent: () => {
				return (
					<div
						style={{
							width: '100%',
							paddingTop: '10px',
							cursor: 'pointer',
						}}
						onClick={() => sortDataList({ order_by: 'roles', sort_by: 'asc' })}
					>
						<div
							style={{
								width: '55px',
							}}
						>
							<p
								style={{
									display: 'flex',
									alignItems: 'center',
									color: 'black',
								}}
							>
								ROLES
								<span
									style={{
										fontSize: '18px',
										fontWeight: '800',
									}}
								>
									{sortIconMap[sortDirection?.roles]}
								</span>
							</p>
						</div>
					</div>
				);
			},
			cellRenderer: (params) => {
				return <div className="d-flex align-items-center h-100" style={{ fontSize: '13px' }}>{params.data.role}</div>;
			},
		},
		{
			field: 'ACTION',
			headerClass: 'HeaderBg left-align',
			suppressSizeToFit: true,
			minWidth: 200,
			maxWidth: 250,
			flex: 1,
			cellClass: 'left-align',
			cellRenderer: (params) => {
				const data = JSON.parse(params.data['action']);
				return (
					<div className="d-flex gap-3 align-items-center justify-content-center h-100">
						<div
							className="d-flex justify-content-center fs-6 fw-semibold text-center rounded-4 px-4 bg-primary cursor-pointer text-white" style={{ height: 'fit-content', fontSize: '13px' }}
							onClick={(e) => {
								e.stopPropagation();
								setIsEdit(true);
								setIsOpenModal(true);
								setSelectedUserId(data.id);
							}}
						>
							Edit
						</div>
						{/* Disable/Enable is hidden for the owner (locks the customer out of
						    their own workspace) and for drafts (activating here would skip
						    the required-details check and produce an account whose password
						    reset goes to an unreachable placeholder address). Both are
						    rejected server-side too — this only avoids offering the button. */}
						{!data.is_owner && !data.is_draft && (
							<div
								className="fs-6 fw-semibold rounded-4 px-4 cursor-pointer text-white"
								style={{ backgroundColor: data.is_active ? '#FF0000' : '#0d6efd' }}
								onClick={(e) => {
									handleDisable(e, data.id, !data.is_active);
								}}
							>
								{data.is_active ? 'Disable' : 'Enable'}
							</div>
						)}
					</div>
				);
			},
		},
	];

	// Blocked only when capacity is KNOWN to be exhausted. While it is still
	// loading (or the call failed) the button stays enabled — the API enforces
	// the same limit, so the worst case is a clear error message rather than a
	// button that looks permanently broken.
	const seatsExhausted = capacity !== null && capacity.can_add_user === false;

	return (
		<div>
			<SettingHeaderComponent
				title={activeTab}
				buttons={[
					{
						id: 1,
						button: 'Add User',
						add: true,
						close: false,
						disabled: seatsExhausted,
						handler: () => {
							if (seatsExhausted) return;
							setIsOpenModal(true);
							setIsEdit(false);
							setSelectedUserId('');
						},
						className: 'btn-primary',
					},
				]}
			/>
			<div style={{ backgroundColor: '#EDEDF7', position: 'sticky', top: 0, zIndex: 99 }}>
				<div className="d-flex pt-2 px-3 pb-3 justify-content-between align-items-center">
					{/* The filter dropdown and the seat count are siblings in one flex
					    row. The count used to sit inside the dropdown wrapper, which
					    stacked it under the filter with no separation. */}
					<div
						className="product-pg-header tax-dropdown-header p-0 d-flex align-items-center gap-5"
						style={{
							position: 'sticky',
							top: 0,
							zIndex: 100,
						}}
					>
						<div className="dropdown text-end">
							<a
								className="link-dark text-decoration-none dropdown-toggle p-0"
								id="dropdownUser1"
								data-bs-toggle="dropdown"
								aria-expanded="false"
							>
								<span className="fs-3 fw-bold">{headerDropDown}</span>
							</a>
							<ul
								className="dropdown-menu font-14"
								aria-labelledby="dropdownUser1"
								style={{ minWidth: '200px', zIndex: '10000' }}
							>
								<li>
									<a
										className="dropdown-item border-0"
										onClick={() => handleFilterData('All Users', '', '')}
									>
										All Users
									</a>
								</li>
								<li>
									<a
										className="dropdown-item border-0"
										onClick={() => handleFilterData('Active Users', 'active', 'status')}
									>
										Active Users
									</a>
								</li>
								<li>
									<a
										className="dropdown-item border-0"
										onClick={() => handleFilterData('Inactive Users', 'inactive', 'status')}
									>
										Inactive Users
									</a>
								</li>
								<li>
									<a
										className="dropdown-item border-0"
										onClick={() => handleFilterData('Draft Users', 'draft', 'status')}
									>
										Draft Users
									</a>
								</li>
								<li>
									<a
										className="dropdown-item border-0"
										onClick={() => handleFilterData('Free Users', 'free', 'plan')}
									>
										Free Users
									</a>
								</li>
								<li>
									<a
										className="dropdown-item border-0"
										onClick={() => handleFilterData('Paid Users', 'paid', 'plan')}
									>
										Paid Users
									</a>
								</li>
							</ul>
						</div>
						{/* Seats used, shown whether or not the limit is reached. A count
						    that only appears once Add User breaks tells the admin too late
						    — this way they can see the ceiling coming. */}
						<SubscriptionUsageIndicator
							usageData={usageData}
							moduleKey="users"
							className="ms-4"
						/>
					</div>
				</div>
			</div>
			{loader ? (
				<PageLoader />
			) : (
				<div className="productTable-body">
					<Table
						row={usersList}
						coloum={usersTableColumn}
						className="productTable"
						onRowClick={onRowClick}
						bulkAction={bulkAction}
						action={setBulkAction}
						onDeselectAll={handleDeselectAll}
					/>
				</div>
			)}
			{isOpenModel && (
				<CreateUserModal
					isOpenModal={isOpenModel}
					setIsOpenModal={setIsOpenModal}
					userId={selectedUserId}
					isEdit={isEdit}
					getUsersList={getUsersList}
				/>
			)}
			{
				<UserDrawer
					setIsOpenModal={setIsOpenModal}
					setIsEdit={setIsEdit}
					isOpen={isDrawerOpen}
					onClose={() => setIsDrawerOpen(false)}
					id={selectedUserId}
				/>
			}
		</div>
	);
}
